import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import CampaignsBar from "../CampaignsBar/CampaignsBar";
import { useSelector } from "react-redux";
import { Message } from "semantic-ui-react";
import { getCampaigns, getUsers } from "store/selectors";
import LoadResolver from "components/LoadResolver";
import Campaigns from "../Campaigns/Campaigns";
import _ from "lodash";
import { ACTIVE_CAMPAIGN_STATUSES, INACTIVE_CAMPAIGN_STATUSES } from "constants/campaignStatuses";

export const CampaignsTable = ({ onlyInactiveCampaigns, maxNrOfMergeCampaigns, dispatch, t }) => {
  const { isLoading, error, items, activeIsLazyLoading, inactiveIsLazyLoading } = useSelector(
    getCampaigns
  );
  const users = useSelector(getUsers);
  const isLazyLoading = onlyInactiveCampaigns ? inactiveIsLazyLoading : activeIsLazyLoading;

  const groups = useMemo(() => {
    if (!items || !items.length) return [];

    const filteredItems = onlyInactiveCampaigns
      ? _.filter(items, (group) => _.includes(INACTIVE_CAMPAIGN_STATUSES, group.status))
      : _.filter(items, (group) => _.includes(ACTIVE_CAMPAIGN_STATUSES, group.status));

    return filteredItems.map((campaign) => ({
      ...campaign,
      sender: users?.items?.find((user) => user.id === campaign.owner) || "",
    }));
  }, [items, onlyInactiveCampaigns, users]);

  const { activeCampaignsLoaded, inactiveCampaignsLoaded } = useSelector(
    (state) => state.campaignsPage
  );

  useEffect(() => {
    dispatch.campaigns.resetCsvData();
  }, [dispatch]);

  useEffect(() => {
    if (!onlyInactiveCampaigns && !activeCampaignsLoaded) {
      dispatch.campaignsPage.onActiveCampaignsLoaded();
      dispatch.campaigns.loadActive();
    } else if (onlyInactiveCampaigns && !inactiveCampaignsLoaded) {
      dispatch.campaigns.loadInactive();
      dispatch.campaignsPage.onInactiveCampaignsLoaded();
    }
  }, [onlyInactiveCampaigns, activeCampaignsLoaded, inactiveCampaignsLoaded, dispatch]);

  const currentPageKey = useMemo(
    () => (onlyInactiveCampaigns ? "inactive-campaigns" : "campaigns"),
    [onlyInactiveCampaigns]
  );

  return (
    <>
      <div className="page-nav" style={{ marginTop: "2em" }}>
        <CampaignsBar currentPageKey={currentPageKey} />
      </div>
      {!groups || !groups.length ? (
        <LoadResolver isLoading={isLoading || users.isLoading} error={error}>
          <div className="page-container">
            <Message>
              {t("campaigns_table_no_data")}
              <br />
              <Link to="/deliverNew">{t("campaigns_table_create_link")}</Link>
            </Message>
          </div>
        </LoadResolver>
      ) : (
        <Campaigns
          groups={groups}
          maxNrOfMergeCampaigns={maxNrOfMergeCampaigns}
          currentPageKey={currentPageKey}
          onlyInactiveCampaigns={onlyInactiveCampaigns}
          isLazyLoading={isLazyLoading}
          t={t}
        />
      )}
    </>
  );
};
